import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        team_id: '',
        name: ''
      },
      params: {
        role: '',
        coaches: ''
      },
      tabledata: [],
      coachTyoeList: [{
        label: '主教练',
        value: 'head'
      }, {
        label: '助理教练',
        value: 'assistant'
      }, {
        label: '球员兼教练',
        value: 'player'
      }, {
        label: '领队',
        value: 'leader'
      }]
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getCoachesListFn();

                if (data) {
                  _this.formData.team_id = data;
                }

                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getCoachesListFn: function getCoachesListFn() {
      var _this2 = this;

      this.$api.unboundCoachesList(this.formData).then(function (res) {
        if (res.code == 200) {
          _this2.tabledata = res.data;
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var ids = e.map(function (item) {
        return item.id;
      }).toString();
      this.params.coaches = ids;
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this3.params.coaches || !_this3.params.role)) {
                  _context2.next = 3;
                  break;
                }

                _this3.$message.error('请选择教练职位和教练');

                return _context2.abrupt("return");

              case 3:
                data = JSON.parse(JSON.stringify(_this3.params));

                _this3.$api.bindTeamByCoach(_objectSpread(_objectSpread({}, data), {}, {
                  team_id: _this3.formData.team_id
                })).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success('操作成功');

                    _this3.$emit('change');

                    _this3.dialogFormVisible = false;
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};